import { Loading, useGetList } from 'react-admin';
import { Timeline, TimelineItem, TimelineSeparator, TimelineDot, TimelineConnector, TimelineContent, TimelineOppositeContent } from '@mui/lab';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Avatar from '@mui/material/Avatar';
import PersonIcon from '@mui/icons-material/Person';
import StatisticheBoard from '../statistiche/StatisticheBoard';

// Funzione per creare il payload
function createPayload(data) {
    const x = data.map(item => item.descrMacroArea);
    const y = data.map(item => item.valoreAssegnato);

    return [{
        x: x,
        y: y,
        type: 'bar',
        name: 'Macro Aree',
        marker: {
            color: ['#FFD700', '#FF8C00', '#FF6347', '#4682B4', '#6A5ACD',
                '#FF4500', '#DB7093', '#2E8B57', '#D2691E', '#8B008B',
                '#7FFFD4', '#B22222', '#B4169E1', '#CFB53B'
            ]
        }
    }];
}

const GetGraficoQuiz = ({ tblQuizId }) => {

    const { data, total, isLoading, error } = useGetList(
        'view-quiz-punteggio-con-valore-assegnato',
        {
            pagination: { page: 1, perPage: 20 },
            // sort: { field: 'published_at', order: 'DESC' }
            filter: {
                tblQuizId: tblQuizId
            }
        }
    );
    if (isLoading) { return <Loading />; }
    if (error) { return <p>ERROR</p>; }


    // console.log(data);
    const datax = createPayload(data);

    // Uso del componente


    return (<StatisticheBoard datax={datax} email={data[0].email} updatedAt={data[0].updatedAt} />
    );
};

export default GetGraficoQuiz;